module.exports = __webpack_public_path__ + "media/src/images/message_sp-091e0045d574dd47b9b8b796ab8f58b2.svg";